"use client";

import { useEffect } from "react";

export default function CleverTapTracker() {
  useEffect(() => {
    const clevertap = require("clevertap-web-sdk");

    clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.init("8RK-K48-547Z", "eu1", "");

    const urlParams = new URLSearchParams(window.location.search);
    clevertap.event.push("Landing Page Viewed", {
      utm_source: urlParams.get("utm_source"),
      utm_medium: urlParams.get("utm_medium"),
      utm_campaign: urlParams.get("utm_campaign"),
    });
  }, []);

  return null;
}
